export const MODIFY_IMPORT_SHEET_READ = 'MODIFY_IMPORT_SHEET_READ';

export function modifyImportSheetRead(importSheetRead){
    return{
        type: MODIFY_IMPORT_SHEET_READ,
        mainState: {
            importSheetRead: importSheetRead
        }
    }
}